import { confirmAction } from '@/composables/useConfirmAction';
import { pushLegacyToast } from '@/iframe/legacyDialogs';

// Messages of the Vue pages that replaced legacy ones (login, portal): the same alerts and toasts the legacy
// raised with swal / toast, rendered by the chrome's single NavConfirmDialog and snackbar queue (AppChrome).

const ALERT_ICONS = { success: 'check_circle', warning: 'warning', info: 'info', error: 'error' };

/**
 * A one-button alert (sweetalert `swal({ title, text, type })`). Resolves when the user closes it with OK.
 * @param {{ title: string, text?: string, type?: 'success'|'warning'|'info'|'error', confirmText?: string }} options
 */
export function showAlert({ title, text = '', type = 'info', confirmText = 'OK' }) {
	return new Promise((resolve) => {
		confirmAction({ title, lines: text ? String(text).split('\n').filter(Boolean) : [], icon: ALERT_ICONS[type] ?? ALERT_ICONS.info, confirmText, cancelText: null, run: () => resolve(true) });
	});
}

// js/Main.js toast(message, type, isHtml).
export const showToast = (message, type = 'success', isHtml = false) => pushLegacyToast(message, type, isHtml);
